import styled from 'styled-components';

export const ErrorContainer = styled('div')`
  margin-top: auto;
  padding-top: 30px;
  padding-bottom: 20px;
`;

export const Content = styled('div')`
  text-align: center;
  background: #eeeeee;
  border-radius: 5px;
  padding: 20px;
  font-weight: bold;
  font-size: 18px;
  color: #333;
`;
